import { useT } from '../i18n/index.js';
import { Idioma } from './Idioma.js';

/**
 * Shown instead of the app when the page is not in a secure context.
 *
 * Without `crypto.subtle` nobody can sign in and no service worker registers, so there is no
 * PIN and no offline mode — the two things this system is. Letting someone reach the PIN pad
 * and fail there would be worse than refusing here: the error would look like a wrong PIN.
 *
 * The case is specific and common: `pnpm dev` on a laptop works because localhost is treated as
 * secure, and then the same URL opened on a phone over the wifi is not.
 */
export function ContextoInseguro() {
  const t = useT();
  const url = typeof location === 'undefined' ? '' : location.host;

  return (
    <div className="mx-auto flex min-h-dvh max-w-md flex-col items-center justify-center gap-5 p-6 text-center">
      <Idioma tamano="compacto" />

      <h1 className="text-xl font-bold text-amber-200">{t('inseguro.titulo')}</h1>

      <p className="text-sm text-slate-400">
        {t('inseguro.explicacion')}
        {url && <> {t('inseguro.abiertaEn', { host: url })}</>}
      </p>

      <div className="tarjeta w-full text-left text-sm text-slate-400">
        <p className="mb-2 font-medium text-slate-200">{t('inseguro.comoSeguir')}</p>
        <ul className="flex list-disc flex-col gap-1.5 pl-4">
          <li>{t('inseguro.opcionLocal')}</li>
          <li>{t('inseguro.opcionDominio')}</li>
        </ul>
      </div>

      <p className="text-xs text-slate-600">{t('inseguro.noEsDeAqui')}</p>
    </div>
  );
}
